import React from "react";
import nextId from "react-id-generator";
import CustomDropdown from "../../../Common/CustomDropdown/CustomDropdown";

export default function EmploymentForm({
  data,
  setEmploymentData,
  employmentData,
  num,
  handleDelete,
  handleChanges,
  current,
  error,
}) {
  const handleChange = (e) => {
    let temp = {
      ...data,
      currently_working: e.target.checked,
    };
    employmentData.candidate_employment[num] = { ...temp };
    setEmploymentData({
      ...employmentData,
      candidate_employment: [...employmentData.candidate_employment],
    });
  };
  return (
    <div className="employment-form">
      {num ? (
        <div className="e-form-header">
          <p>Add Qualification ({num + 1})</p>
          <button onClick={() => handleDelete(num)}>Delete</button>
        </div>
      ) : (
        ""
      )}
      <div
        className={`fancy-input ${
          current && error && !data.institute_name ? "error" : ""
        }`}
      >
        <span>Institute Name*</span>
        <input
          value={data.institute_name}
          placeholder="Goa University"
          onChange={(e) =>
            handleChanges({ ...data, institute_name: e.target.value }, num)
          }
        />
      </div>

      <CustomDropdown
        list={curriculumList}
        error={current && error && !data.curriculum}
        title="Curriculum*"
        message="Select"
        sendClicked={(obj) =>
          handleChanges({ ...data, curriculum: obj.id }, num)
        }
        selected={data.curriculum}
      />

      <CustomDropdown
        list={designationList}
        error={current && error && !data.designation}
        title="Designation*"
        message="Select"
        sendClicked={(obj) =>
          handleChanges({ ...data, designation: obj.id }, num)
        }
        selected={data.designation}
      />

      <CustomDropdown
        error={current && error && !data.class}
        sendClicked={(obj) => handleChanges({ ...data, class: obj.id }, num)}
        list={classes}
        title="Class*"
        message="Select"
        selected={data.class}
      />
      <div className="worked-range">
        <h6>Worked From*</h6>
        <div className="worked-range-wrapper">
          <div className="range-wrapper">
            <CustomDropdown
              error={current && error && !data.worked_from.month}
              sendClicked={(obj) =>
                handleChanges(
                  {
                    ...data,
                    worked_from: { ...data.worked_from, month: obj.id },
                  },
                  num
                )
              }
              list={months}
              title=""
              message="Select Month"
              selected={data.worked_from.month}
            />
          </div>
          <div className="range-wrapper">
            <CustomDropdown
              error={current && error && !data.worked_from.year}
              sendClicked={(obj) =>
                handleChanges(
                  {
                    ...data,
                    worked_from: { ...data.worked_from, year: obj.name },
                  },
                  num
                )
              }
              list={years}
              title=""
              message="Select Year"
              selected={data.worked_from.year}
            />
          </div>
        </div>
      </div>
      <div className="current-check">
        <label>
          <input
            onChange={(e) => handleChange(e)}
            checked={data.currently_working}
            type="checkbox"
          />
          I'm currently Working in this role
        </label>
      </div>
      {!data.currently_working && (
        <div className="worked-range">
          <h6>Worked Until*</h6>
          <div className="worked-range-wrapper">
            <div className="range-wrapper">
              <CustomDropdown
                error={
                  current &&
                  error &&
                  !data.worked_till.month &&
                  data.currently_working
                }
                sendClicked={(obj) =>
                  handleChanges(
                    {
                      ...data,
                      worked_till: { ...data.worked_till, month: obj.id },
                    },
                    num
                  )
                }
                list={months}
                title=""
                message="Select Month"
                
              selected={data.worked_till.month}
              />
            </div>
            <div className="range-wrapper">
              <CustomDropdown
                error={
                  current &&
                  error &&
                  !data.worked_till.year &&
                  data.currently_working
                }
                sendClicked={(obj) =>
                  handleChanges(
                    {
                      ...data,
                      worked_till: { ...data.worked_till, year: obj.name },
                    },
                    num
                  )
                }
                list={years}
                title=""
                message="Select Year"
                selected={data.worked_till.year}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const curriculumList = [
  { _id: nextId(), name: "CBSE", id: "cbse" },
  { _id: nextId(), name: "NCERT", id: "ncert" },
  { _id: nextId(), name: "IGCSE", id: "IGCSE" },
  { _id: nextId(), name: "PU", id: "PU" },
  { _id: nextId(), name: "IB", id: "IB" },
  { _id: nextId(), name: "Higher Education", id: "Higher Education" },
];
const designationList = [
  { _id: nextId(), name: "Teacher", id: "teacher" },
  { _id: nextId(), name: "Headmaster", id: "head" },
  { _id: nextId(), name: "Principal", id: "pricipal" },
];

const classes = [
  { _id: nextId(), name: "Class 1 - 4", id: "1_4" },
  { _id: nextId(), name: "Class 5 - 8", id: "5_8" },
  { _id: nextId(), name: "Class 8 - 10", id: "8_10" },
];
const months = [
  { _id: nextId(), name: "January", id: "jan" },
  { _id: nextId(), name: "February", id: "feb" },
  { _id: nextId(), name: "March", id: "march" },
  { _id: nextId(), name: "April", id: "april" },
  { _id: nextId(), name: "May", id: "may" },
  { _id: nextId(), name: "June", id: "june" },
  { _id: nextId(), name: "July", id: "july" },
  { _id: nextId(), name: "August", id: "aug" },
  { _id: nextId(), name: "September", id: "sept" },
  { _id: nextId(), name: "October", id: "oct" },
  { _id: nextId(), name: "November", id: "nov" },
  { _id: nextId(), name: "December", id: "dec" },
];

const years = [
  { _id: nextId(), name: "2020" },
  { _id: nextId(), name: "2019" },
  { _id: nextId(), name: "2018" },
  { _id: nextId(), name: "2017" },
  { _id: nextId(), name: "2016" },
  { _id: nextId(), name: "2015" },
  { _id: nextId(), name: "2014" },
  { _id: nextId(), name: "2013" },
  { _id: nextId(), name: "2012" },
  { _id: nextId(), name: "2011" },
  { _id: nextId(), name: "2010" },
  { _id: nextId(), name: "2009" },
  { _id: nextId(), name: "2008" },
  { _id: nextId(), name: "2007" },
  { _id: nextId(), name: "2006" },
  { _id: nextId(), name: "2005" },
  { _id: nextId(), name: "2004" },
  { _id: nextId(), name: "2003" },
  { _id: nextId(), name: "2002" },
  { _id: nextId(), name: "2001" },
  { _id: nextId(), name: "2000" },
  { _id: nextId(), name: "1999" },
  { _id: nextId(), name: "1998" },
  { _id: nextId(), name: "1997" },
  { _id: nextId(), name: "1996" },
  { _id: nextId(), name: "1995" },
  { _id: nextId(), name: "1994" },
  { _id: nextId(), name: "1993" },
  { _id: nextId(), name: "1992" },
  { _id: nextId(), name: "1991" },
  { _id: nextId(), name: "1990" },
];
